var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    { attrs: { width: 100, height: 20, secondary: _vm.color } },
    [
      _c("rect", {
        attrs: { rx: "50", height: "15", width: "15", y: "0", x: "40" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "50", height: "15", width: "15", y: "0", x: "60" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "50", height: "15", width: "15", y: "0", x: "80" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }